export default __webpack_public_path__ + "static/media/p4.538429b3.jpeg";